export default __webpack_public_path__ + "69b35663b4a479592ff1c215267b9c29.svg";